/** Profile statuses (ProfileStatusField) and release stages (the stage dots). */
export type StatusDotTone =
  | 'active'
  | 'inactive'
  | 'processing'
  | 'unknown'
  | 'production'
  | 'test'
  | 'development'
  | 'archived'
  | 'default'

const PROFILE_TONES: Readonly<Record<string, StatusDotTone>> = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PROCESSING: 'processing',
  UNKNOWN: 'unknown'
}

// PARITY Q9: the releases code says ARCHIVE, the wave/tenant dots ARCHIVED; both are archived.
const STAGE_TONES: Readonly<Record<string, StatusDotTone>> = {
  PRODUCTION: 'production',
  TEST: 'test',
  DEVELOPMENT: 'development',
  ARCHIVE: 'archived',
  ARCHIVED: 'archived'
}

/** A profile's `status` → dot tone. Exact uppercase match, as the portal's switch; anything else is unknown. */
export function profileStatusTone(status: string | null | undefined): StatusDotTone {
  return (status && Object.hasOwn(PROFILE_TONES, status) && PROFILE_TONES[status]) || 'unknown'
}

/** A release stage → dot tone. Exact uppercase match; anything else gets the fallback colour. */
export function stageTone(stage: string | null | undefined): StatusDotTone {
  return (stage && Object.hasOwn(STAGE_TONES, stage) && STAGE_TONES[stage]) || 'default'
}
